module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('items-list', {
    staticClass: "nav-container",
    class: {
      'is-small': _vm.small
    },
    style: (_vm.styles),
    attrs: {
      "items": _vm.items,
      "level": 1,
      "max-level": _vm.maxLevel,
      "small": _vm.small
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e1dd458","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/Default.vue
// module id = 5028e82c0736d2a34d02
// module chunks = 0